$(document).ready(function(){

    // Reviews carousel: native overflow-x scroll, arrows scroll the track by one card
    $('.cad-carousel').each(function(){
        var $section = $(this);
        var $track = $section.find('.cad-carousel-track');
        if (!$track.length) return;

        function step() {
            var $slide = $track.find('.cad-carousel-slide').first();
            var gap = parseFloat($track.css('column-gap')) || 0;
            return $slide.outerWidth() + gap;
        }

        $section.find('.cad-carousel-prev').on('click', function(){
            $track[0].scrollBy({ left: -step(), behavior: 'smooth' });
        });
        $section.find('.cad-carousel-next').on('click', function(){
            $track[0].scrollBy({ left: step(), behavior: 'smooth' });
        });
    });

    // Deal countdown (shared end time across all offer boxes, restarts when it hits zero)
    var $timers = $('.cad-offer-timer');
    if ($timers.length) {
        var minutes = parseInt($timers.first().data('minutes'), 10) || 10;
        var storageKey = 'cad_deal_end';

        function getEnd() {
            var end = 0;
            try { end = parseInt(sessionStorage.getItem(storageKey), 10) || 0; } catch (e) {}
            if (end <= Date.now()) {
                end = Date.now() + minutes * 60 * 1000;
                try { sessionStorage.setItem(storageKey, end); } catch (e) {}
            }
            return end;
        }

        function pad(n) {
            return (n < 10 ? '0' : '') + n;
        }

        var end = getEnd();
        function tick() {
            var left = end - Date.now();
            if (left <= 0) {
                end = getEnd();
                left = end - Date.now();
            }
            var totalSeconds = Math.floor(left / 1000);
            $timers.text(pad(Math.floor(totalSeconds / 60)) + ' : ' + pad(totalSeconds % 60));
        }
        tick();
        setInterval(tick, 1000);
    }

    // Sticky CTA: show once the hero button has scrolled out of view
    var $sticky = $('.cad-sticky');
    if ($sticky.length) {
        var $anchor = $('.cad-hero-btn').first();
        function toggleSticky() {
            var threshold = $anchor.length ? $anchor.offset().top + $anchor.outerHeight() : 600;
            $sticky.toggleClass('is-visible', $(window).scrollTop() > threshold);
        }
        toggleSticky();
        $(window).on('scroll resize', toggleSticky);
    }
});
